import { useMemo, useCallback } from 'react';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import Searcher from '../../../../ReclamoCreation/components/tabs/components/searchFields/Searcher';
import { GET_PROVEEDORES_SAP, adaptProveedoresSapArray } from '../../../../../data/graphQL/queries/Profesionales/getProveedoresSap';

const ProveedoresSapField = ({
    datosGeneralesFormData,
    handleChange,
    disabled,
    idDelegacion
}) => {
    const CONFIGURATED_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(columns)), [columns]);

    const getSearchParams = useCallback((textValue) => {
        const filterDelegacion = {
        };

        const searchParams = {
            and: [filterDelegacion]
        };

        if (textValue) {
            const textValueMayus = textValue.toUpperCase();
            searchParams.and.push({
                or: [
                    { nombre: { contains: textValueMayus } },
                    { cUIT: { contains: textValueMayus } },
                    { cod_Proveedor: { contains: textValueMayus } }
                ]
            });
        }

        return searchParams;
    }, [idDelegacion]);

    const handleRowClick = (row) => {
        handleChange('cod_Proveedor', row?.cod_Proveedor);
        handleChange('cuitSAP', row?.cuit);
    }

    const getEntityValue = (row) => {
        const value = !!row ? row.cod_Proveedor : null
        return value;
    }

    return <Searcher
        displayName='Codigo SAP'
        titleModal='Buscador Proveedor SAP'
        entityName='proveedoresSAPPaginated'
        entityId='cod_Proveedor'
        entityIdValue={datosGeneralesFormData?.cod_Proveedor}
        columns={CONFIGURATED_COLUMNS}
        query={GET_PROVEEDORES_SAP}
        adapter={adaptProveedoresSapArray}
        getSearchParams={getSearchParams}
        onRowClick={handleRowClick}
        getEntityValue={getEntityValue}
        disabled={disabled}
    />
}

export default ProveedoresSapField;

const columns = [
    {
        field: 'cod_Proveedor',
        headerName: 'Cod_Proveedor',
        flex: 2
    },
    {
        field: 'nombre',
        headerName: 'Nombre',
        flex: 2
    },
    {
        field: 'cuit',
        headerName: 'CUIT',
        flex: 2
    },
    {
        field: 'localidad',
        headerName: 'Localidad',
        flex: 2
    }
];